var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-element-number-input-demo"}},[_c('number-input-default'),_c('number-input-color'),_c('number-input-min-max'),_c('number-input-size'),_c('number-input-step'),_c('number-input-decimal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }